<template>

<div>
<el-row type="flex" class="row-bg" justify="center">
  <el-col :xs="20" :span="16">
  <el-menu class="el-menu-demo" mode="horizontal">
  <el-menu-item index="1"><a href="/">Home</a></el-menu-item>
  <el-menu-item index="2"><a href="/apps">Apps</a></el-menu-item>
  <!-- <el-menu-item index="3"><a href="/about">About</a></el-menu-item> -->
  <el-menu-item index="4"><a href="/terms">Terms</a></el-menu-item>
  <el-menu-item index="5"><a href="/privacy">Privacy</a></el-menu-item>
</el-menu>

<div class="line"></div>
</el-col>
</el-row>

<el-row type="flex" class="row-bg" justify="center">
  <el-col :xs="20" :span="16">
 <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="Airporty" name="airporty">
    
      <el-row style='margin-top:30px' type="flex" class="row-bg" justify="center">
            <el-col :xs="18" :span="12">
                <el-image style="width: 100px; height: 100px; border-radius: 20%;" src='static/logo_airporty.png' fit="cover">
                </el-image>
            </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :xs="18" :span="16">
              <h1>Airporty</h1>
              <p> Over 43,000 Airport Procedure Charts for the USA </p>
              <p> Search for airport information of over 55,000 ICAO's </p>
              <p> Coming soon: Airport Procedure Charts for Brazil and France!  </p>
              <el-link :underline='false' href='https://apps.apple.com/us/app/airporty/id1471027705'> <img class="appstorebadge" src="/static/appstore.svg"> </el-link>
                            
            </el-col>
        </el-row>


  </el-tab-pane>
  <el-tab-pane label="Property Survey" name="supergeo">

        <el-row style='margin-top:30px' type="flex" class="row-bg" justify="center">
            <el-col :xs="18" :span="12">
                <el-image style="width: 100px; height: 100px; border-radius: 20%;" src='static/logo.jpg' fit="cover">
                </el-image>
            </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :xs="18" :span="16">
              <h1>Property Survey</h1>
              <p>The most accurate tool to perform property or land survey. </p>
              <p> Perfect for creating quotes that require precise and accurate measurements. </p>
              <el-link href='https://apps.apple.com/us/app/property-survey-gps/id1264090172?ls=1&mt=8'> <img class="appstorebadge" src="/static/appstore.svg"> </el-link>
                            
            </el-col>
        </el-row>


  </el-tab-pane>
    <el-tab-pane label="Invoice Maker" name="invoicemaker">

        <el-row style='margin-top:30px' type="flex" class="row-bg" justify="center">
            <el-col :xs="18" :span="12">
                <el-image style="width: 100px; height: 100px; border-radius: 20%;" src='static/invoice_maker.jpg' fit="cover">
                </el-image>
            </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :xs="18" :span="16">
              <h1>Invoice Maker</h1>
              <p> Use Invoice Maker to send simple invoices using professional templates, PDF invoices and quotes and more — all in one easy-to-use app. </p> 
              
              <p> Small business owners trust Invoice Maker to send professional invoices and estimates to clients.</p>
              
              <el-link href='https://apps.apple.com/us/app/property-survey-gps/id1264090172?ls=1&mt=8'> <img class="appstorebadge" src="/static/appstore.svg"> </el-link>
                            
            </el-col>
        </el-row>


  </el-tab-pane>
    <el-tab-pane label="eFipe" name="efipe">

            <el-row style='margin-top:30px' type="flex" class="row-bg" justify="center">
            <el-col :xs="18" :span="12">
                <el-image style="width: 100px; height: 100px; border-radius: 20%;" src='static/logofipe.jpg' fit="cover">
                </el-image>
            </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :xs="18" :span="16">
              <h1>eFipe</h1>
              <p> A melhor forma de acompanhar o preço de carros usados. </p>
              <p> Fácil de buscar, tabela de comparativos e gráfico de depreciação! </p>
              <el-link href='https://apps.apple.com/us/app/tabela-fipe-de-carros-usados/id1464431324?ls=1&mt=8'> <img class="appstorebadge" src="/static/appstore.svg"> </el-link>
                            
            </el-col>
        </el-row>


</el-tab-pane>
    <el-tab-pane label="Tabela Taco" name="tabelataco">

            <el-row style='margin-top:30px' type="flex" class="row-bg" justify="center">
            <el-col :xs="18" :span="12">
                <el-image style="width: 100px; height: 100px; border-radius: 20%;" src='static/logo_supertaco.jpg' fit="cover">
                </el-image>
            </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :xs="18" :span="16">
              <h1>Tabela de Alimentos Taco </h1>
              <p> A Tabela Brasileira de Composição de Alimentos (TACO) é fruto de um projeto coordenado pelo NEPA da UNICAMP com o apoio e financiamento dos Ministérios da Saúde e do Desenvolvimento Social. </p>
              <p> Este aplicativa torna fácil a busca e a customização pesos e medidas dos componentes de cada alimento específico.</p>
              
              <el-link href='https://apps.apple.com/us/app/tabela-de-alimentos-taco/id1462182870?ls=1&mt=8'> <img class="appstorebadge" src="/static/appstore.svg"> </el-link>
                            
            </el-col>
        </el-row>

    </el-tab-pane>
  </el-tabs>

    <div class="grid-content bg-purple">


  </div>
</el-col>
</el-row>

</div>

</template>

<script>
export default {
  name: 'Apps',
  data () {
    return {
      activeName: 'airporty'
    }
  },
  methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Apps.vue